/* @flow */

import type { State } from 'src/shared/core/type/reduxTypes';

const segment = (state) => state.ui.onboarding;

export const isSplashSeen = (state: State): boolean =>
  segment(state).isSplashSeen;

export const isOnboardingCompletedOnDevice = (state: State): boolean =>
  segment(state).isCompletedOnDevice;
